import { createAction, props } from '@ngrx/store';

import { EstateState } from '../../reducers/estate/estate.reducer';

export const EstateUpdate = createAction(
  '[Estate] Update Estate State',
  props<{ payload: EstateState }>(),
);
